import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal, { getWatermarkTag } from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const UploadedImageRow: FC<Props> = ({ image, imageIndex, setImages }) => {
  const settingsApplied = getWatermarkTag(image) !== 'none';

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showText={false}
      showSettings
      showPreview={false}
      settingsApplied={settingsApplied}
      aspectRatio={700 / 883}
      imgRatioX={61}
      imgRatioY={76}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages as any}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(UploadedImageRow);
